import React, { useContext } from 'react';
import { func, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { EventTypes } from '../../../../../shared/utils/events/types';
import eventsReporter from '../../../../../shared/utils/events/reporter';
import SharedContext from '../../../../../shared/context';
import ItemTab from './ItemTab';
import { getTabs } from './utils/getTabs';

import './style.scss';

const { itemTabs } = EventTypes.collectionPage;

const ItemTabs = ({ activeTab, gigsView, sellersView, onChange = Function.prototype }) => {
    const { businessId } = useContext(SharedContext);

    const isBusiness = !!businessId;

    const tabs = getTabs({
        isBusiness,
        gigsTotal: gigsView.total,
        sellersTotal: sellersView.total,
    });

    const onTabClick = (name) => {
        eventsReporter.report(itemTabs.tab.clicked, {
            tabName: name,
        });

        onChange(name);
    };

    return (
        <section className="item-tabs">
            {tabs.map(({ name, title }) => (
                <ItemTab key={name} name={name} title={title} isActive={activeTab === name} onClick={onTabClick} />
            ))}
        </section>
    );
};

ItemTabs.propTypes = {
    activeTab: string.isRequired,
    onChange: func,
    gigsView: object,
    sellersView: object,
};

const mapStateToProps = ({ gigsView, sellersView }) => ({
    gigsView,
    sellersView,
});

export { ItemTabs };
export default connect(mapStateToProps)(ItemTabs);
